import { createMuiTheme } from '@material-ui/core';

import typography from './typography';
import overrides from './overrides';
import palette from './palette';

const theme = () =>
  createMuiTheme({
    palette,
    typography: typography(palette),
    overrides: overrides(palette),
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
  });

export default theme;
